import axios from 'axios';

const BASE_URL = 'https://pixabay.com/api/';
const API_KEY = '55413565-681c65d92b61373cd91c6707e';

export function getImagesByQuery(query) {
  return axios
    .get(BASE_URL, {
      params: {
        key: API_KEY,
        q: query,
        image_type: 'photo',
        orientation: 'horizontal',
        safesearch: true,
      },
    })
    .then(response => response.data);
}
